import React, {useState} from 'react'
import {connect} from 'react-redux'
import {registerCompany, getMyCompany, getCompanies, sendRequest, clearCopmanies, getAllRequest, cancelRequest, getCompanyRequest, rejectRequest, acceptRequest} from 'actions/companyActions';
import {getCurrentUser} from 'actions/userActions'
import {changePasswordProfile} from 'actions/authActions'
import Spinner from 'components/common/Spinner';
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    Input,
    Label,
    FormGroup,
    Col,
    Row,
    Form,
    Modal,
    CardTitle,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane
} from "reactstrap";
import {clearEditErrors, editCompany} from "../../actions/companyActions";

const ProfilePage = (props) => {
    const {registerCompany, errorRegister, loadingRegister, getMyCompany, loadingMy, 
        errorMy, myCompany, editCompany,editError,clearEditErrors,loadingEdit, getCurrentUser,currentUser, loadingUser, errorUser,
        getCompanies, companies, loadingCompanies, errorComapnies, clearCopmanies,
        sendRequest, reqestResponse, loadingRequest, errorRequest,
        getAllRequest, allRequests, loadingAllRequests, errorAllRequests,
        cancelRequest, loadingCancel, errorCancel, cancelResponse,
        getCompanyRequest, companyRequests, loadingCompanyRequests, errorCompanyRequests,
        rejectRequest,
        acceptRequest,
        changePasswordProfile, errorPass, res, auth_loading } = props
    const [formValues, setFormValues] = useState({
        name: "",
        street: "",
        street_nr: "",
        postal_code: "",
        city: "",
        nip: "",
        regon: "",
        wojewodztwo: "",
        powiat: "",
        gmina: "",
        category: "",
        form: "",
        krs: "",
        indirect_cost_settings: "",
        management_cost_settings: ""
    })

    const fillEditForm = () => {
        setFormValues({
            name: myCompany.name,
            street: myCompany.street,
            street_nr: myCompany.street_nr,
            postal_code: myCompany.postal_code,
            city: myCompany.city,
            nip: myCompany.nip,
            regon: myCompany.regon,
            wojewodztwo: myCompany.wojewodztwo,
            powiat: myCompany.powiat,
            gmina: myCompany.gmina,
            category: myCompany.category!=null?myCompany.category:'',
            form: myCompany.form!=null?myCompany.form:'',
            krs: myCompany.krs
        })


    }
    React.useEffect(() => {
        const asyncWrapper = async () => { 
            getMyCompany()
            getCurrentUser()
            clearCopmanies()
        }
        asyncWrapper()
    }, [])
    React.useEffect(()=>{
        if(currentUser){getAllRequest({user_requester: currentUser.id})}
        if(currentUser && currentUser.is_company_creator){getCompanyRequest({})}
    },[currentUser])
    React.useEffect(()=>{
        if(!loadingRequest){getCurrentUser()}
    },[loadingRequest])
    const [modalMini, setModalMini] = useState(false);
    const [modalMiniReq, setModalMiniReq] = useState(false);
    const [modalMiniCancel, setModalMiniCancel] = useState(false);
    const [modalMiniReject, setModalMiniReject] = useState(false);
    const [modalMiniAccept, setModalMiniAccept] = useState(false);
    const toggleModalMini = () => {
        setModalMini(!modalMini);
    };
    const [allowEdit, setAllowEdit] = useState(false);

    const handleFieldChange = (e) => {
        const fieldValue = e.target.value;
        const fieldIndex = e.target.id

        setFormValues((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues[fieldIndex] = fieldValue;
            return prevLoginValues;
        });
    }

    const categoryOpt = {
        'SKI': 'Szpital kliniczny/instytut',
        'SW': 'Szpital wojewódzki/monoprofilowy',
        'SGPM': 'Szpital gminny/powiatowy/miejski',
        'SAI': 'Specjalistyka ambulatoryjna /rehabilitacją/stomatologią',
        'SAIPOZ': 'POZ ze specjalistyką/rehabilitacją/stomatologią',
        'MSWIA': 'Pozostałe(MSWiA, wojskowe)',
        'SIU': 'Sanatoria i uzdrowiska',
        'ODP': 'Opieka długoterminowa pozaszpitalna',
        'RM': 'Ratownictwo medyczne'
    }
    const podmiot = {
        'PP': 'Podmiot publiczny',
        'PN': 'Podmiot niepubliczny',
    }
    const wojew = {
        "08": "Opolskie",
        "13": "Świętokrzyskie",
        "02": "Kujawsko-pomorskie",
        "07": "Mazowieckie",
        "11": "Pomorskie",
        "12": "Śląskie",
        "14": "Warmińsko-mazurskie",
        "16": "Zachodniopomorskie",
        "01": "Dolnośląskie",
        "15": "Wielkopolskie",
        "05": "Łódzkie",
        "10": "Podlaskie",
        "06": "Małopolskie",
        "04": "Lubuskie",
        "09": "Podkarpackie",
        "03": "Lubelskie",
    }
    const dictZarzad = {'koszty':"według wartości kosztu wytworzenia OPK", "przychody":"według wartości przychodów OPK"}
    const handleSubmit = (e) => {
        // e.preventDefault();
        formValues.wojewodztwo = wojew[formValues.wojewodztwo]
        formValues["calc_settings"] = {
            id: "",
            "indirect_cost_settings": "",
            "management_cost_settings": ""
        }
        registerCompany(formValues)
        toggleModalMini()
    }
    React.useEffect(()=>{
        getMyCompany()
        getCurrentUser()
    },[loadingRegister])

    const submitEdit = () => {
        formValues.wojewodztwo = wojew[formValues.wojewodztwo]
        formValues["calc_settings"] = {
            id: myCompany.calc_settings ? myCompany.calc_settings.id : "",
            "indirect_cost_settings": formValues.indirect_cost_settings,
            "management_cost_settings": formValues.management_cost_settings
        }
        editCompany(formValues, myCompany.id)
        toggleModalMini()}
    const [horizontalTabs, setHorizontalTabs] = useState("existCompany");
    const [horizontalTabsAdmin, setHorizontalTabsAdmin] = useState("company");
    const [krsToSearch, setKrsToSearch] = useState("")
    const searchCompany = (event) =>{
        if(event.key === "Enter") {
            let params = {krs:krsToSearch}
            getCompanies(params)}}
    const sendReq = () => {
        let formData ={company:companies[0].id}
        sendRequest(formData)
        getCurrentUser()
        setModalMiniReq(true)
        if(currentUser){getAllRequest({user_requester: currentUser.id})}
    }
    const CancelJoinRequest = () =>{
        cancelRequest(idToCancel)
        getCurrentUser()
        setModalMiniCancel(false)
    }
    const [idToCancel, setIdToCancel] = useState(null)
    const [idToReject, setIdToReject] = useState(null)
    const [idToAccept, setIdToAccept] = useState(null)
    const toggleModalMiniCancel = (id) =>{
        setIdToCancel(id)
        setModalMiniCancel(true)
    }
    const rejectReq = (id) =>{
        setIdToReject(id)
        setModalMiniReject(!modalMiniReject)
    }
    const RejectJoinRequest = () =>{
        rejectRequest(idToReject)
        rejectReq(null)
    }
    const acceptReq = (id) =>{
        setIdToAccept(id)
        setModalMiniAccept(!modalMiniAccept)
    }
    const AcceptJoinRequest = () =>{
        acceptRequest(idToAccept)
        acceptReq(null)
    }
    const [formPass, setFormPass] = useState({pw1:"", pw2:""})
    const handleFieldChangePass = (e) => {
        const fieldValue = e.target.value;
        const fieldIndex = e.target.id

        setFormPass((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues[fieldIndex] = fieldValue;
            return prevLoginValues;
        });
    }
    const changePassword = () =>{
        changePasswordProfile(formPass)
        setModalMiniPass(true)

    }
    const [modalMiniPass, setModalMiniPass] = useState(false);



    const returnForm = () => {
        return (
            <Form className="settings-form okraglaczki">
                                <Row>
                                    <Col sm="12">
                                        <FormGroup>
                                            <label>{`${'Nazwa firmy'}`}</label>
                                            <Input
                                                className="border-input"
                                                placeholder={`${'Nazwa firmy'}`}
                                                type="text"
                                                value={formValues['name']}
                                                onChange={(e) => handleFieldChange(e)}
                                                id="name"
                                                // value = {}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4" sm="12">
                                        <FormGroup>
                                            <label>{`${"NIP"}`}</label>
                                            <Input
                                                className="border-input"
                                                placeholder={`${"NIP"}`}
                                                type="text"
                                                value={formValues['nip']}
                                                onChange={(e) => handleFieldChange(e)}
                                                id="nip"
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4" sm="12">
                                        <FormGroup>
                                            <label>{`${"Regon"}`}</label>
                                            <Input
                                                className="border-input"
                                                placeholder={`${"Regon"}`}
                                                type="text"
                                                value={formValues['regon']}
                                                onChange={(e) => handleFieldChange(e)}
                                                id="regon"

                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4" sm="12">
                                        <FormGroup>
                                            <label>{`${"KRS"}`}</label>
                                            <Input
                                                className="border-input"
                                                placeholder={`${"KRS"}`}
                                                type="text"
                                                value={formValues['krs']}
                                                onChange={(e) => handleFieldChange(e)}
                                                id="krs"

                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="8" sm="12">
                                        <FormGroup>
                                            <label>{`${'Ulica'}`}</label>
                                            <Input
                                                className="border-input"
                                                placeholder={`${'ulica'}`}
                                                type="text"
                                                value={formValues['street']}
                                                onChange={(e) => handleFieldChange(e)}
                                                id="street"

                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4" sm="12">
                                        <FormGroup>
                                            <label>{`${"Numer"}`}</label>
                                            <Input
                                                className="border-input"
                                                placeholder={`${"Numer"}`}
                                                type="text"
                                                value={formValues['street_nr']}
                                                onChange={(e) => handleFieldChange(e)}
                                                id="street_nr"

                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" sm="12">
                                        <FormGroup>
                                            <label>{`${"Kod pocztowy"}`}</label>
                                            <Input
                                                className="border-input"
                                                placeholder={`${"Kod pocztowy"}`}
                                                type="text"
                                                value={formValues['postal_code']}
                                                onChange={(e) => handleFieldChange(e)}
                                                id="postal_code"

                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="6" sm="12">
                                        <FormGroup>
                                            <label>{`${"Miasto"}`}</label>
                                            <Input
                                                className="border-input"
                                                placeholder={`${"Miasto"}`}
                                                type="text"
                                                value={formValues['city']}
                                                onChange={(e) => handleFieldChange(e)}
                                                id="city"

                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4" sm="12">
                                        <FormGroup>
                                            <label>{`${"Gmina"}`}</label>
                                            <Input
                                                className="border-input"
                                                placeholder={`${"Gmina"}`}
                                                type="text"
                                                value={formValues['gmina']}
                                                onChange={(e) => handleFieldChange(e)}
                                                id="gmina"

                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4" sm="12">
                                        <FormGroup>
                                            <label>{`${"Powiat"}`}</label>
                                            <Input
                                                className="border-input"
                                                placeholder={`${"Powiat"}`}
                                                type="text"
                                                value={formValues['powiat']}
                                                onChange={(e) => handleFieldChange(e)}
                                                id="powiat"

                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md="4" sm="12">
                                        <FormGroup>
                                            <label>{`${"Województwo"}`}</label>
                                            <Input type="select" name="selectWojew" id="wojewodztwo"
                                                   value={formValues['wojewodztwo']}
                                                   onChange={(e) => handleFieldChange(e)}>
                                                <option disabled value={""}>Wybierz...</option>
                                                {Object.entries(wojew).map(([key, value], i) => {
                                                    return <option value={key} key={`wojewodztwo_${i}`}>{value}</option>
                                                })}
                                            </Input>
                                            {/* <Input
                                            className="border-input"
                                            placeholder={`${"Województwo"}`}
                                            type="text"
                                            /> */}
                                        </FormGroup>
                                    </Col>
                                    <Col md="7" sm="12">
                                        <FormGroup>
                                            <Label for="category">Kategoria</Label>
                                            <Input type="select" name="select" id="category"
                                                   value={formValues['category']}
                                                   onChange={(e) => handleFieldChange(e)}>
                                                <option value={""} disabled>{"Wybierz"}</option>
                                                {Object.entries(categoryOpt).map(([key, value], i) => {
                                                    return <option value={key} key={`category_${i}`}>{value}</option>
                                                })}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md="7" sm="12">
                                        <FormGroup>
                                            <Label for="exampleSelect">Forma prawna</Label>
                                            <Input type="select" name="select" id="form" value={formValues['form']}
                                                   onChange={(e) => handleFieldChange(e)}>
                                                <option value={""} disabled>{"Wybierz"}</option>
                                                {Object.entries(podmiot).map(([key, value], i) => {
                                                    return <option value={key} key={`form_${i}`}>{value}</option>
                                                })}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    {Object.getOwnPropertyNames(myCompany).length !== 0 && false && <Col md="7" sm="12">
                                        <FormGroup>
                                            <Label for="exampleSelect">Sposób wyliczenia kosztów bezpośrednich</Label>
                                            <Input type="select" name="select" id="indirect_cost_settings"
                                                   value={formValues['indirect_cost_settings']}
                                                   onChange={(e) => handleFieldChange(e)}>
                                                <option value={""} disabled>{"Wybierz"}</option>
                                                <option value={"iteracyjnie"}>{"Iteracyjnie"}</option>
                                                <option value={"bezposrednio"}>{"Bezposrednio"}</option>

                                            </Input>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="exampleSelect">Sposób rozliczenia kosztów zarządu</Label>
                                            <Input type="select" name="select" id="management_cost_settings"
                                                   value={formValues['management_cost_settings']}
                                                   onChange={(e) => handleFieldChange(e)}>
                                                <option value={""} disabled>{"Wybierz"}</option>
                                                <option value={"koszty"}>{"według wartości kosztu wytworzenia OPK"}</option>
                                                <option value={"przychody"}>{"według wartości przychodów OPK"}</option>

                                            </Input>
                                        </FormGroup>
                                    </Col>}
                                </Row>
                                {Object.getOwnPropertyNames(myCompany).length === 0 && <div className="text-center">
                                    <Button
                                        className="btn-round"  color="aotmit" outline  size="sm"
                                        // color="info"
                                        type="button"
                                        onClick={(e) => handleSubmit(e)}
                                    >
                                        Dodaj
                                    </Button>

                                </div>}
                                {allowEdit && <div className="text-center ">
                                    <Button
                                        className="btn-round"  color="aotmit" outline size="sm"
                                        onClick={e => submitEdit()}>
                                        Zapisz zmiany
                                    </Button>
                                    <Button
                                        className="btn-round"  color="aotmit-red" outline size="sm"
                                        onClick={e => setAllowEdit(false)}>
                                        Anuluj
                                    </Button>
                                </div>}
                            </Form>
        )
    }

    return (
        <div className="content">
            <Row>
                <Col className="ml-auto mr-auto" md="7">
                    {!loadingMy ? <>{Object.getOwnPropertyNames(myCompany).length === 0  ? <Card>
                        <CardBody>
                        <div className="nav-tabs-navigation">
                            <div className="nav-tabs-wrapper">
                                <Nav id="tabs" role="tablist" tabs>
                                <NavItem>
                                    <NavLink style={{cursor: 'pointer'}}
                                    aria-expanded={horizontalTabs === "newCompany"}
                                    data-toggle="tab"
                                    // href="#pablo"
                                    role="tab"
                                    className={horizontalTabs === "newCompany" ? "active" : ""}
                                    onClick={() => setHorizontalTabs("newCompany")}
                                    >
                                    Utwórz firmę
                                    </NavLink>
                                </NavItem> 
                                <NavItem>
                                    <NavLink style={{cursor: 'pointer'}}
                                    aria-expanded={horizontalTabs === "existCompany"}
                                    data-toggle="tab"
                                    // href="#pablo"
                                    role="tab"
                                    className={horizontalTabs === "existCompany" ? "active" : ""}
                                    onClick={() => setHorizontalTabs("existCompany")}
                                    >
                                       Dołącz do firmy
                                    </NavLink>
                                </NavItem>
                                
                                </Nav>
                            </div>
                        </div>
                        <TabContent
                            className="text-center"
                            id="my-tab-content"
                            activeTab={horizontalTabs}
                            >
                            <TabPane tabId="newCompany" role="tabpanel">
                                {!loadingUser && currentUser && !currentUser.waiting_for_accept ? <>
                                {returnForm()}</>:<div>Oczekujesz na dołączenie do firmy</div>}
                            </TabPane>
                            <TabPane tabId="existCompany" role="tabpanel">
                                { !loadingUser && currentUser && !currentUser.waiting_for_accept ?<div>
                                    <CardTitle style={{textAlign:'left'}}> Aby dołączyć do istniejacej firmy podaj jej <strong>nr KRS</strong> oraz wciśnij enter:</CardTitle>
                                   <Row> 
                                       <Col sm="12"  style={{marginTop:"15px"}}>
                                        <FormGroup>
                                            {/* <label>{`${'NR KRS firmy'}`}</label> */}
                                            <Input
                                                className="border-input"
                                                placeholder={`${"KRS"}`}
                                                type="text"
                                                value={krsToSearch}
                                                onChange={(e) => setKrsToSearch(e.target.value)}
                                                id="city"
                                                onKeyUp={searchCompany}

                                            />
                                        </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row style={{marginTop:"25px"}}>
                                        <Col sm="12" style={{textAlign:'left'}}>
                                            {!loadingCompanies && companies && companies.length!==0 ? <>
                                            
                                            <Row>
                                                <Col md="8">
                                                    {/* <FormGroup> */}
                                                        <div style={{marginTop:"5px"}}><label style={{marginRight:"10px"}}>{`${'Nazwa firmy'}`}:</label>{companies[0].name}</div>
                                                    {/* </FormGroup> */}
                                                </Col>
                                                <Col md='4'>
                                                    <FormGroup>
                                                        <Button className="btn-round" style={{margin:"0px"}} color="aotmit" outline type="button" size="sm" onClick={()=>{sendReq()}}>Dołącz</Button>
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            </>:<> {companies !==null? <>Brak firmy o wybranym numerze KRS, sprawdź poprawność wpisanego numeru.</>:<></>}</>}
                                        </Col>
                                    </Row>
                                </div>:<div>{!loadingAllRequests && allRequests && <div style={{textAlign:"left"}}>Oczekujesz na dołączenie do firmy:
                                    {allRequests.map((element, i)=> {return <Row className='mt-3 mb-3' style={{textAlign:"left"}} key={`request_${i}`}>
                                        <Col md="5" ms='12'>
                                            <FormGroup>
                                                <label>Nazwa firmy</label>
                                                <div> {element.company_name}</div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="3" ms='12'>
                                            <FormGroup>
                                                <label>KRS firmy</label>
                                                <div> {element.company_krs}</div>
                                            </FormGroup>
                                        </Col>
                                        <Col md="4" ms='12'>
                                            {!element.request_canceled && !element.request_rejected ?<FormGroup>
                                                <Button className="btn-round" style={{}} color="aotmit" outline type="button" size="sm" onClick={()=>{toggleModalMiniCancel(element.id)}}>Anuluj prośbę</Button>
                                            </FormGroup>:<><label>Status</label><div>Anulowano/odrzucono</div></>}
                                        </Col>
                                    </Row>})}
                                    </div>}</div>}
                             </TabPane>
                        </TabContent>
                        </CardBody>
                    </Card> : 
                    <><Card>
                    <CardBody>
                    <div className="nav-tabs-navigation" style={{borderBottom: '1px solid #17728d'}}>
                            <div className="nav-tabs-wrapper">
                    <Nav id="tabs2" role="tablist" tabs  className="profilNav">
                    <NavItem className="">
                        <NavLink style={{cursor: 'pointer'}}
                        aria-expanded={horizontalTabsAdmin === "company"}
                        data-toggle="tab"
                        // href="#pablo"
                        role="tab"
                        className={horizontalTabsAdmin === "company" ? "active" : ""}
                        onClick={() => setHorizontalTabsAdmin("company")}
                        tabIndex={'0'}
                         onKeyDown={(e) => {
                             if (e.key === 'Enter') {
                                 setHorizontalTabsAdmin("company")
                             }
                         }}
                        >
                           Twoja firma
                        </NavLink>
                    </NavItem>
                    {!loadingUser && currentUser && currentUser.is_company_creator && <NavItem className=''>
                        <NavLink style={{cursor: 'pointer'}}
                        aria-expanded={horizontalTabsAdmin === "acceptance"}
                        data-toggle="tab"
                        // href="#pablo"
                        role="tab"
                        className={horizontalTabsAdmin === "acceptance" ? "active" : ""}
                        onClick={() => setHorizontalTabsAdmin("acceptance")}
                         tabIndex={'0'}
                         onKeyDown={(e) => {
                             if (e.key === 'Enter') {
                                 setHorizontalTabsAdmin("acceptance")
                             }
                         }}
                        >
                        Prośby o dołączenie
                        </NavLink>
                    </NavItem>} 
                    {/* nowe hasło */}
                    <NavItem className="">
                        <NavLink style={{cursor: 'pointer'}}
                        aria-expanded={horizontalTabsAdmin === "changeData"}
                        data-toggle="tab"
                        // href="#pablo"
                        role="tab"
                        className={horizontalTabsAdmin === "changeData" ? "active" : ""}
                        onClick={() => setHorizontalTabsAdmin("changeData")}
                         tabIndex={'0'}
                         onKeyDown={(e) => {
                             if (e.key === 'Enter') {
                                 setHorizontalTabsAdmin("changeData")
                             }
                         }}
                        >
                           Zmiana hasła
                        </NavLink>
                    </NavItem>
                    {/* nowe hasło */}
                    </Nav>
                    </div></div>
                    <TabContent
                        id="my-tab-content"
                        activeTab={horizontalTabsAdmin}>
                        <TabPane tabId="company" role="tabpanel">
                      {!allowEdit ? 
                        <CardBody>
                            {/* <CardTitle>Twoja firma</CardTitle> */}
                            <Row className='profileForm'>
                                <Col sm="12">
                                    <FormGroup>
                                        <label>{`${'NAZWA FIRMY'}`}</label>
                                        <div style={{color:'#17728d'}}>{myCompany.name}</div>
                                    </FormGroup><hr/>
                                </Col>
                                <Col md="4" sm="12">
                                    <FormGroup>
                                        <label>{`${"NIP"}`}</label>
                                        <div>{myCompany.nip}</div>
                                    </FormGroup>
                                </Col>
                                <Col md="4" sm="12">
                                    <FormGroup>
                                        <label>{`${"Regon"}`}</label>
                                        <div>{myCompany.regon}</div>
                                    </FormGroup>
                                </Col>
                                <Col md="4" sm="12">
                                    <FormGroup>
                                        <label>{`${"KRS"}`}</label>
                                        <div>{myCompany.krs}</div>
                                    </FormGroup>
                                </Col>
                                <Col sm='12'><hr/></Col>
                                <Col md="8" sm="12">
                                    <FormGroup>
                                        <label>{`${'Ulica'}`}</label>
                                        <div>{myCompany.street}</div>
                                    </FormGroup>
                                </Col>
                                <Col md="4" sm="12">
                                    <FormGroup>
                                        <label>{`${"Numer"}`}</label>
                                        <div>{myCompany.street_nr}</div>
                                    </FormGroup>
                                </Col>
                                <Col md="6" sm="12">
                                    <FormGroup>
                                        <label>{`${"Kod pocztowy"}`}</label>
                                        <div>{myCompany.postal_code}</div>
                                    </FormGroup>
                                </Col>
                                <Col md="6" sm="12">
                                    <FormGroup>
                                        <label>{`${"Miasto"}`}</label>
                                        <div>{myCompany.city}</div>
                                    </FormGroup>
                                </Col>
                                <Col md="4" sm="12">
                                    <FormGroup>
                                        <label>{`${"Gmina"}`}</label>
                                        <div>{myCompany.gmina}</div>
                                    </FormGroup>
                                </Col>
                                <Col md="4" sm="12">
                                    <FormGroup>
                                        <label>{`${"Powiat"}`}</label>
                                        <div>{myCompany.powiat}</div>
                                    </FormGroup>
                                </Col>
                                <Col md="4" sm="12">
                                    <FormGroup>
                                        <label>{`${"Województwo"}`}</label>
                                        <div>{myCompany.wojewodztwo}</div>
                                    </FormGroup>
                                </Col>
                                <Col sm='12'><hr/></Col>
                                <Col md="7" sm="12">
                                    <FormGroup>
                                        <Label for="category">Kategoria</Label>
                                        <div>{categoryOpt[myCompany.category]}</div>
                                    </FormGroup>
                                </Col>
                                <Col sm='12'><hr/></Col>
                                <Col sm="12">
                                    <FormGroup>
                                        <Label for="exampleSelect">Forma prawna</Label>
                                        <div>{podmiot[myCompany.form]}</div>
                                    </FormGroup>
                                </Col>
                                {!allowEdit && false && <Col md="7" sm="12">
                                    <FormGroup>
                                        <Label for="exampleSelect">Sposób rozliczenia kosztów pośrednich procedur medycznych:</Label>
                                        <div>{myCompany.calc_settings ? myCompany.calc_settings.indirect_cost_settings : ""}</div>
                                    </FormGroup>

                                    {/*                    <Col md="7" sm="12">*/}
                                    {/*<FormGroup>*/}
                                    {/*  <Label for="exampleSelect">Sposób wyliczenia kosztów proecdury</Label>*/}
                                    {/*  <div>{myCompany.procedural_cost_settings}</div>*/}
                                    {/*</FormGroup>*/}
                                    {/*</Col>*/}

                                    <FormGroup>
                                        <Label for="exampleSelect">Sposób rozliczenia kosztów zarządu:</Label>
                                        <div>{myCompany.calc_settings ? dictZarzad[myCompany.calc_settings.management_cost_settings] : ""}</div>
                                    </FormGroup>
                                </Col>}
                            </Row>
                            {!loadingUser && currentUser && currentUser.is_company_creator && <div className="text-center">
                                <Button
                                    className="btn-round"  color="aotmit" outline  size="sm"
                                    // color="info"
                                    onClick={e => {
                                        setAllowEdit(true);
                                        fillEditForm()
                                    }}
                                >
                                    Edytuj
                                </Button>
                            </div>}
                        </CardBody>:<CardBody>{returnForm()}</CardBody>}</TabPane>
                        <TabPane tabId='acceptance' role='tabpanel'>
                            <div>
                                <CardBody>
                                    <Row>
                                        <Col sm='12' md='12'>
                                        Oczekujące na akceptacje wnioski o dołączenie do firmy:<br></br><br></br>
                                        {!loadingCompanyRequests && companyRequests!==null  ? <>
                                        {companyRequests.length!==0 ?companyRequests.map((el, i)=>{return <React.Fragment key={`await_${i}`}>
                                        {!el.request_accepted && !el.request_rejected && <Row>
                                            <Col md="3" ms='12'>
                                            <FormGroup>
                                                <label>Imię</label>
                                                <div>{el.user_firstname}</div>
                                            </FormGroup>
                                            </Col>
                                            <Col md="3" ms='12'>
                                            <FormGroup>
                                                <label>Nazwisko</label>
                                                <div>{el.user_lastname}</div>
                                            </FormGroup>
                                            </Col>
                                            <Col md="3" ms='12' className='text-cenrter'>
                                                <Button className="btn-round"  color="aotmit" outline type="button" size="sm" onClick={()=>{acceptReq(el.id)}}>Zaakceptuj</Button>
                                            </Col>
                                            <Col md="3" ms='12' className='text-cenrter'>
                                                <Button className="btn-round"  color="aotmit" outline type="button" size="sm" onClick={()=>{rejectReq(el.id)}}>Odrzuć</Button>
                                            </Col>
                                            </Row>}</React.Fragment>
                                        }):<span style={{color:"rgb(0 0 0 / 66%)"}}>Brak</span>}</>:<><Col md="12" ms='12'>Brak zapytań</Col></>}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm='12' md='12'><br/>
                                        Wnioski zaakceptowane:
                                        {!loadingCompanyRequests && companyRequests!==null  ? <>
                                        {companyRequests.map((el, i)=>{return <React.Fragment key={`accepted_${i}`}>
                                        {el.request_accepted && <Row>
                                            <Col md="4" ms='12'>
                                            <FormGroup>
                                                <label>Imię</label>
                                                <div>{el.user_firstname}</div>
                                            </FormGroup>
                                            </Col>
                                            <Col md="4" ms='12'>
                                            <FormGroup>
                                                <label>Nazwisko</label>
                                                <div>{el.user_lastname}</div>
                                            </FormGroup>
                                            </Col>
                                            <Col md="4" ms='12' className='text-cenrter'>
                                                <label>Data zaakceptowania</label>
                                                <div>{el.date_accepted}</div>
                                            </Col>
                                            </Row>}</React.Fragment>
                                        })}</>:<><Col md="12" ms='12'>Brak zapytań</Col></>}
                                        </Col>
                                    </Row>

                                </CardBody>
                            </div>
                        </TabPane>
                        <TabPane tabId='changeData' role='tabpanel'>
                        <div>
                            <CardBody>
                                <Row >
                                <Row className='pb-2 mx-2'><Col sm='1' md='1' className='m-auto'><i className="nc-icon nc-alert-circle-i"/></Col>
                                <Col sm='11' md='11' className='p-0'><i>Hasło powinno mieć co najmniej 8 znaków oraz zawierać wielką literę, cyfrę i&nbsp;znak specjalny.</i></Col>  
                               </Row><br/><br/> 
                                   
                                    <Col sm='12' md='12'>
                                        <FormGroup>
                                            <label htmlFor={'pw1'}>{`${"Nowe hasło"}`}</label>
                                            <Input
                                                className="border-input"
                                                placeholder={`${"nowe hasło"}`}
                                                type="password"
                                                value={formPass['pw1']}
                                                onChange={(e) => handleFieldChangePass(e)}
                                                id="pw1"

                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <label htmlFor={'pw2'}>{`${"Powtórz nowe hasło"}`}</label>
                                            <Input
                                                className="border-input"
                                                placeholder={`${"powtórz hasło"}`}
                                                type="password"
                                                value={formPass['pw2']}
                                                onChange={(e) => handleFieldChangePass(e)}
                                                id="pw2"
                                                style={(formPass['pw2']!== formPass['pw1'] && formPass['pw2']!=="")? {borderColor:'#ed7d7d'}:{}}

                                            />
                                        </FormGroup>
                                        </Col>
                                        <Col className='text-center'>
                                        <Button
                                            className="btn-round"  color="aotmit" outline  size="sm"
                                            onClick={e => {
                                                changePassword();
                                            }}>Zmień hasło</Button>
                                        </Col>
                                </Row>
                            </CardBody>
                        </div>
                        </TabPane>
                        </TabContent></CardBody></Card></>}</> : <><Spinner></Spinner></>}
                </Col>
            </Row>
            <Modal
                className="modal-sm"
                modalClassName="modal-primary"
                isOpen={modalMini}
                // toggle={toggleModalMini}
            >
                {!allowEdit ? (!loadingRegister ? <>
                    <div className="modal-header justify-content-center">
                        <div className="modal-profile ml-auto mr-auto">
                            {errorRegister === null ? <i className="nc-icon nc-check-2"/> :
                                <i className="nc-icon nc-simple-remove"/>}
                        </div>
                    </div>
                    <div className="modal-body">
                        <p>{errorRegister === null ? 'Twoja firma została pomyślnie utworzona' : "Wszystkie pola muszą być uzupełnione!"}</p>
                    </div>
                    <div className="modal-footer">

                        {errorRegister === null ?
                            <Button
                                color="link"
                                data-dismiss="modal"
                                type="button"
                                onClick={() => toggleModalMini()}
                            >
                                Rozumiem
                            </Button> : <Button
                                color="link"
                                data-dismiss="modal"
                                type="button"
                                onClick={() => toggleModalMini()}
                            >
                                Rozumiem
                            </Button>}
                        {/* </div> */}
                    </div>
                </> : <>
                    <div className="modal-header justify-content-center">
                        <div className="modal-profile ml-auto mr-auto">
                            <i className="fas fa-spinner fa-spin"></i>
                        </div>
                    </div>
                    <div className="modal-body">
                        <p>Przetwarzanie...</p>
                    </div>
                </>):
                    (!loadingEdit ? <>
                    <div className="modal-header justify-content-center">
                        <div className="modal-profile ml-auto mr-auto">
                            {editError === null ? <i className="nc-icon nc-check-2"/> :
                                <i className="nc-icon nc-simple-remove"/>}
                        </div>
                    </div>
                    <div className="modal-body">
                        <p>{editError === null ? 'Pomyślnie udało się zamienić dane firmy' : "Wszystkie pola muszą być uzupełnione!"}</p>
                    </div>
                    <div className="modal-footer">

                        {editError === null ?
                            <Button
                                color="link"
                                data-dismiss="modal"
                                type="button"
                                onClick={() => {
                                    setAllowEdit(false)
                                    toggleModalMini()}}
                            >
                                Rozumiem
                            </Button> : <Button
                                color="link"
                                data-dismiss="modal"
                                type="button"
                                onClick={() => toggleModalMini()}
                            >
                                Rozumiem
                            </Button>}
                        {/* </div> */}
                    </div>
                </> :
                        <>
                    <div className="modal-header justify-content-center">
                        <div className="modal-profile ml-auto mr-auto">
                            <i className="fas fa-spinner fa-spin"></i>
                        </div>
                    </div>
                    <div className="modal-body">
                        <p>Przetwarzanie...</p>
                    </div>
                </>)}

            </Modal>
            <Modal
                className="modal-sm"
                modalClassName="modal-primary"
                isOpen={modalMiniReq}>
                <div className="modal-header justify-content-center">
                    <div className="modal-profile ml-auto mr-auto">
                    {!loadingRequest && errorRequest === null ? <i className="nc-icon nc-check-2"/> :
                    <i className="nc-icon nc-simple-remove"/>}
                    </div>
                </div>
                <div className="modal-body">
                    {!loadingRequest ? <p>{errorRequest === null ? 'Pomyślnie wysłano zapytanie do firmy' : "Wystąpił błąd, spróbuj ponownie"}</p>:<p><Spinner></Spinner></p>}
                </div>
                <div className="modal-footer">
                <Button
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => setModalMiniReq(!modalMiniReq)}>
                    Rozumiem
                </Button> 
                </div>
            </Modal>
            <Modal
                className="modal-sm"
                modalClassName="modal-primary"
                isOpen={modalMiniCancel}>
                <div className="modal-header justify-content-center">
                    Anulacja
                </div>
                <div className="modal-body">
                  <div className="modal-profile ml-auto mr-auto">
                   Czy na pewno chcesz anulować prośbę o dołączenie do firmy ?
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="left-side">
                        <Button
                            color="link"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => CancelJoinRequest()}>
                            Tak
                        </Button> 
                        <Button
                            color="link"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => setModalMiniCancel(!modalMiniCancel)}>
                            Nie
                        </Button> 
                    </div>
                </div>
            </Modal>
            
            <Modal
                className="modal-sm"
                modalClassName="modal-primary"
                isOpen={modalMiniReject}>
                <div className="modal-header justify-content-center">
                    Odrzucanie wniosku o dołączenie
                </div>
                <div className="modal-body">
                  <div className="modal-profile ml-auto mr-auto">
                   Czy na pewno chcesz odrzucić prośbę o dołączenie do firmy ?
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="left-side">
                        <Button
                            color="link"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => RejectJoinRequest()}>
                            Tak
                        </Button> 
                        <Button
                            color="link"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => rejectReq(null)}>
                            Nie
                        </Button> 
                    </div>
                </div>
            </Modal>
            <Modal
                className="modal-sm"
                modalClassName="modal-primary"
                isOpen={modalMiniAccept}>
                <div className="modal-header justify-content-center">
                    Akceptacja wniosku o dołączenie
                </div>
                <div className="modal-body">
                  <div className="modal-profile ml-auto mr-auto">
                   Czy na pewno chcesz zaakceptować prośbę o dołączenie do firmy ?
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="left-side">
                        <Button
                            color="link"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => AcceptJoinRequest()}>
                            Tak
                        </Button> 
                        <Button
                            color="link"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => acceptReq(null)}>
                            Nie
                        </Button> 
                    </div>
                </div>
            </Modal>
            {/* <Modal
                className="modal-sm"
                modalClassName="modal-primary"
                isOpen={modalMiniCancel}>
                <div className="modal-header justify-content-center">
                </div>
                <div className="modal-body">
                  <div className="modal-profile ml-auto mr-auto">
                    </div>
                </div>
                    <div className="left-side">
                        <Button
                            color="link"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => CancelJoinRequest()}>
                            Tak
                        </Button> 
                </div>
            </Modal> */}
            <Modal
                className="modal-sm"
                modalClassName="modal-primary"
                isOpen={modalMiniPass}>
                <div className="modal-header justify-content-center">
                    <div className="modal-profile ml-auto mr-auto">
                    {!auth_loading && errorPass === null ? <i className="nc-icon nc-check-2"/> :
                    <i className="nc-icon nc-simple-remove"/>}
                    </div>
                </div>
                <div className="modal-body">
                    {!auth_loading ? <p>{errorPass === null ? res: errorPass}</p>:<p><Spinner></Spinner></p>}
                </div>
                <div className="modal-footer">
                <Button
                    color="link"
                    data-dismiss="modal"
                    type="button"
                    onClick={() => setModalMiniPass(!modalMiniPass)}>
                    Rozumiem
                </Button> 
                </div>
            </Modal>
        </div>

    )
}
const mapStateToProps = (state) => ({
    loadingRegister: state.companyReducer.loadingRegister,
    errorRegister: state.companyReducer.errorRegister,
    loadingMy: state.companyReducer.loadingMy,
    errorMy: state.companyReducer.errorMy,
    myCompany: state.companyReducer.myCompany,
    editError: state.companyReducer.editError,
    loadingEdit: state.companyReducer.loadingEdit,
    currentUser: state.UserReducer.currentUser,
    loadingUser: state.UserReducer.loadingUser,
    errorUser: state.UserReducer.errorUser,
    companies: state.companyReducer.companies,
    loadingCompanies: state.companyReducer.loadingCompanies,
    errorComapnies: state.companyReducer.errorComapnies,
    reqestResponse: state.companyReducer.reqestResponse,
    loadingRequest: state.companyReducer.loadingRequest,
    errorRequest: state.companyReducer.errorRequest,
    allRequests: state.companyReducer.allRequests,
    loadingAllRequests: state.companyReducer.loadingAllRequests,
    errorAllRequests: state.companyReducer.errorAllRequests,
    cancelResponse: state.companyReducer.cancelResponse,
    loadingCancel: state.companyReducer.loadingCancel,
    errorCancel: state.companyReducer.errorCancel,
    companyRequests: state.companyReducer.companyRequests,
    loadingCompanyRequests: state.companyReducer.loadingCompanyRequests,
    errorCompanyRequests: state.companyReducer.errorCompanyRequests,
    errorPass: state.authReducer.errorPass,
    res: state.authReducer.res,
    auth_loading: state.authReducer.auth_loading
});

export default connect(mapStateToProps, {clearEditErrors,registerCompany, getMyCompany, editCompany,
     getCurrentUser, getCompanies, sendRequest, clearCopmanies, getAllRequest, cancelRequest, getCompanyRequest, rejectRequest, acceptRequest, changePasswordProfile})(ProfilePage)